import { NoticeCriteriaGroupActivity } from '../../../../../../api/enumerations';
import { TypologyAndCriteriaData } from '../../../../../../api/theHive/criteriaGroups/types';
import {
  TypologypropertyType,
  TypologyPriceType,
  TypologyRuleKeyword,
} from '../../../../../../api/theHive/typology/enumerations';
import {
  ListTypologyData,
  TypologyData,
} from '../../../../../../api/theHive/typology/types';
import { ALL_SIZES, ServiceGroup, Typology, TypologyGroup } from './types';

const generateId = (): number => Date.now() + Math.floor(Math.random() * 1000);

export const createEmptyTypology = (): Typology => ({
  id: generateId(),
  type: TypologypropertyType.SELECT,
  range: TypologyRuleKeyword.SELECT,
  area: '',
  visible: true,
});

// SERVIÇO vazio (typology_group).
export const createEmptyService = (): TypologyGroup => ({
  id: generateId(),
  category: '',
  code: '',
  name: '',
  reportType: '',
  billingUnit: '',
  priceType: TypologyPriceType.FIXO,
  price: 0,
  deadlineByProject: false,
  slaAlertDays: 0,
  slaLimitDays: 0,
  slaUseBusinessDay: null,
  typologies: [createEmptyTypology()],
});

// GRUPO vazio (criteria_group) já com 1 serviço.
export const createEmptyServiceGroup = (): ServiceGroup => ({
  id: generateId(),
  activity: NoticeCriteriaGroupActivity.SELECT,
  criteriaIds: [],
  services: [createEmptyService()],
});

const convertTypology = (data: TypologyData): Typology => {
  // over + 1 é a representação de "Todos os tamanhos" (handoff §3.6).
  const isAllSizes =
    data.rule_keyword === TypologyRuleKeyword.OVER &&
    Number(data.rule_first_value) === 1;

  return {
    id: data.id ?? generateId(),
    type: data.real_estate_type,
    range: isAllSizes ? ALL_SIZES : data.rule_keyword,
    area: isAllSizes ? '' : data.rule_first_value.toString(),
    area2: data.rule_second_value?.toString(),
    visible: true,
  };
};

// Usado na edição de um SERVIÇO (typology_group).
export const convertTypologyGroup = (data: ListTypologyData): TypologyGroup => {
  return {
    id: data.id,
    category: data.category ?? '',
    code: data.code ?? '',
    name: data.name,
    reportType: data.report_type ?? '',
    billingUnit: data.billing_unit ?? '',
    priceType: data.price_type ?? TypologyPriceType.FIXO,
    price: data.price,
    deadlineByProject: data.deadline_by_project ?? false,
    slaAlertDays: data.sla_alert_days ?? 0,
    slaLimitDays: data.sla_limit_days ?? 0,
    slaUseBusinessDay: data.sla_use_business_days,
    typologies: data.typologies.map(convertTypology),
  };
};

// Usado na edição de um GRUPO inteiro (criteria_group).
export const convertServiceGroup = (
  data: TypologyAndCriteriaData
): ServiceGroup => ({
  id: data.id,
  activity: data.activity,
  criteriaIds: (data.criterias ?? []).map((criteria) => criteria.id),
  services: (data.typology_groups ?? []).map(convertTypologyGroup),
});
